import { FC } from 'react';
import { Box } from '../../../Box';

import styles from './index.module.css';

interface HandleProps {
  domain: [number, number];
  handle: {
    id: string;
    value: number;
    percent: number;
  };
  getHandleProps: (id: string) => Record<string, unknown>;
  disabled?: boolean;
}

export const Handle: FC<HandleProps> = ({
  domain: [min, max],
  handle: { id, value, percent },
  getHandleProps
}) => (
  <>
    <Box
      className={styles.handleComponent}
      style={{
        left: `${percent}%`
      }}
      {...getHandleProps(id)}
    />
    <Box
      className={styles.handleMainComponent}
      role="slider"
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      style={{
        left: `${percent}%`
      }}
    />
  </>
);
